import React from 'react';
import { ArrowRightIcon, BackpackIcon, PersonIcon } from '@radix-ui/react-icons';
import { useI18n } from '../i18n';

// Each tool is described by what it gives you, not by the technique. The
// eyebrow names the transform, because that is the thing the tools have in
// common: they all return the photo that was never taken.
const FEATURES = [
  { id: 'arrow-vision', key: 'arrow', icon: <ArrowRightIcon width={22} height={22} />, available: true },
  { id: 'person-remover', key: 'person', icon: <PersonIcon width={22} height={22} />, available: true },
  { id: 'clothing-tryon', key: 'clothing', icon: <BackpackIcon width={22} height={22} />, available: true },
];

const Dashboard = ({ onSelectFeature }) => {
  const { t } = useI18n();

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <p className="eyebrow">{t('dash.eyebrow')}</p>
        <h1>{t('dash.headline')}</h1>
        <p>{t('dash.sub')}</p>
      </div>

      <div className="features-grid">
        {FEATURES.map((feature) => (
          <button
            key={feature.id}
            type="button"
            className={`feature-card ${!feature.available ? 'disabled' : ''}`}
            onClick={() => feature.available && onSelectFeature(feature.id)}
            disabled={!feature.available}
          >
            <span className="feature-specimen">
              <span className="feature-icon">{feature.icon}</span>
            </span>
            <span className="feature-content">
              <h3>{t(`tool.${feature.key}.name`)}</h3>
              <p>{t(`tool.${feature.key}.desc`)}</p>
            </span>
            <span className="feature-arrow">
              {t(`tool.${feature.key}.transform`)}
              <ArrowRightIcon width={14} height={14} />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
